import { Customer } from '../api/CustomersAPI';
import { CustomerStatus } from './customerStatusToTranslationKey';

export type CustomerListFilterCriteria = {
  statuses?: CustomerStatus[];
  employeeIds?: string[];
  withoutUpcomingAppointment?: boolean;
};

export function customerHasUpcomingAppointment(customer: Customer): boolean {
  const meetings =
    customer.enrichedMeetings?.map((enrichedMeeting) => enrichedMeeting.meeting) ||
    customer.meetings ||
    [];
  const nowTs = Date.now();

  return meetings.some((meeting) => {
    if (!meeting?.endTime || meeting.disable) {
      return false;
    }

    const endTs = new Date(meeting.endTime).getTime();
    return !Number.isNaN(endTs) && endTs >= nowTs;
  });
}

export function customerMatchesListFilters(
  customer: Customer,
  filters: CustomerListFilterCriteria,
): boolean {
  const { statuses, employeeIds, withoutUpcomingAppointment } = filters;

  if (statuses && statuses.length > 0 && !statuses.includes(customer.status)) {
    return false;
  }

  if (employeeIds && employeeIds.length > 0) {
    const employeeId = customer.employeeId != null ? String(customer.employeeId) : '';
    if (!employeeIds.includes(employeeId)) {
      return false;
    }
  }

  if (withoutUpcomingAppointment && customerHasUpcomingAppointment(customer)) {
    return false;
  }

  return true;
}
